var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitterSquare = function SvgTwitterSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#twitter-square_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "twitter-square_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0v32h32V0Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#twitter-square_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.25 0H3.75A3.75 3.75 0 0 0 0 3.75v24.5A3.75 3.75 0 0 0 3.75 32h24.5A3.75 3.75 0 0 0 32 28.25V3.75A3.75 3.75 0 0 0 28.25 0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.886 9h2.51l-5.482 6.265 6.448 8.525h-5.049l-3.954-5.17-4.525 5.17h-2.51l5.862-6.701L8 9h5.177l3.575 4.726L20.886 9Zm-.88 13.288h1.39l-8.974-11.865H10.93l9.076 11.865Z",
    fill: "#000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "twitter-square_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgTwitterSquare;